module.exports = function() {
  return new Worker(__webpack_public_path__ + "90d8c86b3ac3aa43fee4.worker.js");
};